module.exports = __webpack_public_path__ + "static/media/twitter.8842dc01.svg";